<template>
  <div>
    <div v-if="deadline" class="px-2">
      <h4 class="mb-3">List Schedule</h4>
      <div v-for="(item, i) in deadline" class="mb-3" :key="i">
        <div
          class="d-flex align-center my-1"
          v-if="i != 0 && deadline[i].end_module !== deadline[i - 1].end_module"
        >
          <h5 class="txt_date notBold" style="color: #a2aaad">
            {{ $date(item.end_module).format("HH:mm a") }}
            &nbsp;
          </h5>
          <v-divider style="border-top-style: dashed"></v-divider>
        </div>
        <div class="d-flex align-center my-1" v-else-if="i == 0">
          <h5 class="txt_date notBold" style="color: #a2aaad">
            {{ $date(item.end_module).format("HH:mm a") }}
            &nbsp;
          </h5>
          <v-divider style="border-top-style: dashed"></v-divider>
        </div>
        <v-card class="pa-3 d-flex justify-space-between" elevation="1">
          <div class="d-flex align-center">
            <v-icon color="var(--g)" class="mr-2">mdi-book</v-icon>
            <div>
              <h4 class="txtSmall color_default">
                {{ item.title }}
              </h4>
              <h6 class="txt_date notBold" style="color: #a2aaad">
                {{ $date(item.end_module).format("dddd, DD MMMM YYYY") }}
              </h6>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div
      class="d-flex flex-column justify-center align-center"
      v-if="!deadline.length"
    >
      <img
        src="../../assets/img/gundam/LMS Aset Illustrasi No Section.png"
        height="150px"
        class="obj_fit"
        alt=""
      />
      <p class="mt-3 mb-0">No assignments yet</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "historyCourseScholar",
  props: ["deadline"],
  data: () => ({}),
  methods: {},
};
</script>

<style></style>
